import type { AxiosResponse } from "axios";

export interface UnknownParamsObject {
  [parameter: string]: string | number;
}

export type Parameters<ParamsObject = UnknownParamsObject> = ParamsObject;

export declare type OperationResponse<Response> = Promise<
  AxiosResponse<Response>
>;

export type FilterModel = {
  items: {
    value?: string;
    field: string;
    operator: string;
  }[];
  logicOperator?: "and" | "or";
};

type SortDirection = "asc" | "desc";

type SortItem = { field: string; sort?: SortDirection | null };

export type SortModel = SortItem[];

export type Nullable<Value> = Value | null;

export type MediaAttributes = {
  uuid: string;
  order: number;
  name: string;
  custom_properties: { [key: string]: any };
  preview_url: null | string;
  original_url: null | string;
  extension?: string;
  size?: number;
};

export enum EmailContactType {
  Standard = "email_standard",
  // Factura = "email_factura",
  // Sale = "email_sale",
}

export enum PhoneContactType {
  Landline = "landline",
  Mobile = "mobile",
  Fax = "fax",
}

export type TextTemplatePlaceholder = {
  label: string;
  value: string;
  description: string;
  type: "conditional" | "variable";
};
